import { render, staticRenderFns } from "./TenderEditTabInvitations.vue?vue&type=template&id=fd012aea&"
import script from "./TenderEditTabInvitations.vue?vue&type=script&lang=js&"
export * from "./TenderEditTabInvitations.vue?vue&type=script&lang=js&"
import style0 from "./TenderEditTabInvitations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports